import { render } from "./CompanyClaims.vue?vue&type=template&id=5438a75a"
import script from "./CompanyClaims.vue?vue&type=script&lang=js"
export * from "./CompanyClaims.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__